<template>
  <div>
    <PageAllow controller="Containers" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="containersKeyword = $event"
                :label="$t('StockContainers.Keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 添加容器 / 容器分类 按钮 -->
              <v-btn
                small
                color="primary"
                @click.stop="currentItemMode = 'new'"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("StockContainers.ObjectName")]) }}
              </v-btn>
              <v-btn
                small
                color="info"
                class="ms-1"
                href="/#/stocks/container-categories"
              >
                {{ $t("StockContainers.Fields.container_categories") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <!-- 分类搜索框 -->
                  <SearcherContainerCategories
                    v-model="stocksContainersSelected"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- 状态 -->
                  <SearcherStatus
                    v-model="options.status"
                    :items="$consts.container.container_flgs"
                    :label="$t('StockContainers.status.ObjectName')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="containers"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.status="{ item }">
              <!-- 状态文字/颜色 -->
              <v-chip
                small
                label
                :color="item.status | stockContainerColor"
                :text-color="item.status | stockContainerTextColor"
              >
                {{ item.status | stockContainerText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 查看 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt</v-icon
                  >
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("StockContainers.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("StockContainers.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip top v-if="item.deletable == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("StockContainers.ObjectName")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 删除 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('StockContainers.ObjectName')"
      @confirm="
        deleteContainer();
        deleteDialog = false;
      "
    />
    <!-- 操作跳转 -->
    <StockContainersDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getContainersFromAPI()"
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherContainerCategories from "@/components/plugins/SearcherContainerCategories";
import Containers from "@/api/containers";
import Stocks from "@/api/stocks";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import StockContainersDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";

const defaultOptions = {
  containersKeyword: "",
  status: [1, 0],
  container_category_code: "",
};

export default {
  components: {
    Breadcrumbs,
    SearcherKeyword,
    SearcherContainerCategories,
    PageAllow,
    DialogDelete,
    StockContainersDetail,
    SearcherStatus,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockContainers"),
          disabled: true,
          href: "/stocks-containers",
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    headers: () => [
      {
        text: i18n.t("StockContainers.Fields.container_name"),
        align: "start",
        sortable: false,
        value: "container_name",
      },
      {
        text: i18n.t("StockContainers.Fields.container_code"),
        align: "start",
        sortable: false,
        value: "container_code",
      },
      {
        text: i18n.t("StockContainers.Fields.container_categories"),
        align: "start",
        sortable: false,
        value: "container_category_name",
      },
      {
        text: i18n.t("StockContainers.Fields.bar_code"),
        align: "start",
        sortable: false,
        value: "bar_code",
      },
      {
        text: i18n.t("StockContainers.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("StockContainers.Fields.edit"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
  },

  data: () => ({
    stock_id: 0,
    stock: {},
    containers: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("containers-options")
        ? sessionStorage.getItem("containers-options")
        : JSON.stringify(defaultOptions)
    ),
    containersKeyword: "",
    currentItemMode: null,
    currentItem: null,
    initialize: 0,
    stocksContainersSelected: null,
    deleteDialog: false,
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stock_id = Number(this.$route.query.stock_id);

      //获取仓库信息
      Stocks.fetchOne(this.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    }
    this.$commonUtils
      .loadOptions("containers", ["stocksContainersSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksContainersSelected":
                this.stocksContainersSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.containersKeyword,
      });
    },
    resetSearch() {
      this.stocksContainersSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getContainersFromAPI() {
      Containers.fetch(
        Object.assign({}, this.options, {
          stock_id: this.stock_id,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.containers = response.data.containers;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    // 弹窗 确认删除
    deleteContainer() {
      if (this.currentItem) {
        Containers.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getContainersFromAPI();
            }
          }.bind(this)
        );
      }
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.stock_id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getContainersFromAPI();
        sessionStorage.setItem(
          "containers-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 高级搜索
    stocksContainersSelected: {
      handler() {
        this.options.container_category_code = this.stocksContainersSelected
          ? this.stocksContainersSelected.category_code
          : "";
        sessionStorage.setItem(
          "containers-stocksContainersSelected",
          JSON.stringify(this.stocksContainersSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>